/* eslint-disable react-hooks/exhaustive-deps */
import { CQSelect } from '@laxmimanogna/code-quick-components';
import React, { useMemo } from 'react';
import { toTitleCase } from '../../../utils/common.utils';

const SplitAuditSpecialtyRow = ({ onSpecialtySelect, selectedValue, currentUpload }) => {
    const specialties = useMemo(() => {
        if (currentUpload?.client_name?.specialties) {
            return currentUpload.client_name.specialties.map(s => ({ label: s.name !== 'ent' ? toTitleCase(s.name) : 'ENT', value: s.id }))
        }
        return [];
    }, [currentUpload]);

    return (
        <CQSelect
            options={specialties}
            variant="primary"
            isSearchable={false}
            value={selectedValue}
            placeholder={'Select'}
            onChange={e => {
                onSpecialtySelect(e.value)
            }}
            styles={{
                control: (s) => ({
                    ...s,
                    borderRadius: 7,
                    height:50,
                    paddingRight: 10,
                    paddingLeft: 10,
                    fontSize: 'sm'
                })
            }}
        />
    );
};

export default SplitAuditSpecialtyRow;
